import { render, staticRenderFns } from "./anlimore.vue?vue&type=template&id=2106c6c9&scoped=true&"
import script from "./anlimore.vue?vue&type=script&lang=js&"
export * from "./anlimore.vue?vue&type=script&lang=js&"
import style0 from "./anlimore.vue?vue&type=style&index=0&id=2106c6c9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2106c6c9",
  null
  
)

export default component.exports